import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./pages/Homepage";
import Player from "./pages/Player";
import Game from "./pages/Game";
import TeamPage from "./pages/TeamPage";
import Standings from "./pages/Standings";
import Leaders from "./pages/Leaders";
import Layout from "./component/layout/layout";
import { TeamProvider } from "./component/context/TeamContext";
import AnalyticsTracker from "./component/AnalyticsTracker";
import { useAdSenseRefresh } from "./component/ads/useAdSenseRefresh";
import Bracket from "./pages/Bracket";

const App: React.FC = () => {
  useAdSenseRefresh();

  return (
    <TeamProvider>
      <Layout>
        <AnalyticsTracker />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/team/:rawTricode" element={<TeamPage />} />
          <Route path="/player/:playerId" element={<Player />} />
          <Route path="/game/:gameId" element={<Game />} />
          <Route path="/standings/" element={<Standings />} />
          <Route path="/leaders/" element={<Leaders />} />
          <Route path="/bracket/" element={<Bracket />} />
        </Routes>
      </Layout>
    </TeamProvider>
  );
};

export default App;
